var _jsxFileName = "/repo/packages/webassets/src/components/SkeletonLoader/InitialComponent.tsx",
  _this = this;
import React from 'react';
var InitialComponent = function InitialComponent(_ref) {
  var _ref$width = _ref.width,
    width = _ref$width === void 0 ? 400 : _ref$width,
    _ref$height = _ref.height,
    height = _ref$height === void 0 ? 130 : _ref$height;
  return /*#__PURE__*/React.createElement("rect", {
    "data-testid": "SkeletonLoader__InitialComponent",
    x: "0",
    y: "0",
    rx: "5",
    ry: "5",
    width: width,
    height: height,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 12,
      columnNumber: 3
    }
  });
};
export default InitialComponent;
//# sourceMappingURL=InitialComponent.js.map